import axios from "@/utils/axios";
import type {
  ManagerList,
  ManagerInfo,
  CreateManager,
  UpdateManager,
} from "./type";

export const getManagerList = async () => {
  const response = await axios.post<ManagerList>("/api/manager/get_list");
  return {
    head_manager: response.data.head_manager,
    managers: response.data.managers,
  };
};

export const getManagerCount = async () => {
  const response = await axios.post<{ max_count: number }>(
    "/api/manager/get_max_count"
  );
  return response.data.max_count;
};

export const getManagerById = async (id: number) => {
  const response = await axios.post<{ manager: ManagerInfo }>(
    "/api/manager/get_by_id",
    {
      manager_id: id,
    }
  );
  return response.data.manager;
};

export const checkEmailUnique = async (email: string) => {
  const response = await axios.post<{ is_unique: boolean }>(
    "/api/manager/check_email_unique",
    { email }
  );
  return response.data.is_unique;
};

export const createManager = async (manager: CreateManager) => {
  const response = await axios.post("/api/manager/create", {
    new_manager_info: manager,
  });
  return response.data;
};

export const updateManager = async (id: number, manager: UpdateManager) => {
  const response = await axios.post("/api/manager/update", {
    manager_id: id,
    manager_info: manager,
  });
  return response.data;
};

export const deleteManager = async (id: number) => {
  const response = await axios.post("/api/manager/delete", {
    manager_id: id,
  });
  return response.data;
};
